import "../Css/Experience.css";
import "../Css/Education.css";
import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { getLogo, getOrganization } from "../AppMethods";

const education = [
    {
        degree: "MSc, Artificial Intelligence",
        institution: "Aristotle University of Thessaloniki (AUTH)",
        duration: "10/2025 - Current",
        grade: "Currently studying"
    },
    {
        degree: "Seminar, Artificial Intelligence",
        institution: "Ethnikon & Kapodistriakon Panepistimion Athinon",
        duration: "04/2025 - 09/2025 (3 academic months)",
        grade: "10/10",
        details: ["Seminar: \"Ανάπτυξη Εφαρμογών Τεχνητής Νοημοσύνης με Python και OpenAI API\""]
    },
    {
        degree: "Seminar, Project Management | Artificial Intelligence",
        institution: "Ethnikon & Kapodistriakon Panepistimion Athinon",
        duration: "01/2025 - 05/2025 (4 academic months)",
        grade: "9.1/10",
        details: ["Seminar: \"Project Management using Artificial Intelligence\""]
    },
    {
        degree: "MSc, Business Computing",
        institution: "University of Macedonia",
        duration: "09/2021 - 02/2023 (1.5 years)",
        grade: "8.19/10",
        details: [
            "Supervisor: Mr. Chatzigeorgiou Alexander",
            "Master Thesis: \"Behavior Driven and Test Driven Development for Quality Assurance of software systems\""
        ]
    },
    {
        degree: "Seminar, Project Management",
        institution: "Ethnikon & Kapodistriakon Panepistimion Athinon",
        duration: "01/2023 - 07/2023 (6 academic months)",
        grade: "8.8/10",
        details: ["Seminar: \"Project Management\""]
    },
    {
        degree: "Seminar, Web Development",
        institution: "Ethnikon & Kapodistriakon Panepistimion Athinon",
        duration: "09/2020 - 03/2021 (5 academic months)",
        grade: "9.8/10",
        details: ["Seminar: \"Ultimate web development for experts with React 16, Angular 7, Vue.Js 2, HTML, JavaScript, jQuery, and Bootstrap 4\""]
    },
    {
        degree: "BSc, Applied Informatics, School of Information Sciences",
        institution: "University of Macedonia",
        duration: "09/2017 - 06/2021 (4 years)",
        grade: "7.2/10",
        details: [
            "Supervisor: Mr. Chatzigeorgiou Alexander",
            "Bachelor Thesis: \"Synthetic Transaction and Up-time Monitoring Systems in IT\""
        ]
    },
    {
        degree: "Science Orientation Group",
        institution: "7th High School of Thessaloniki",
        duration: "09/2014 - 07/2017 (3 years)",
        grade: "18.5/20"
    },
];

const Education = () => {

    const [openItems, setOpenItems] = useState([]);

    const toggleDetails = (index) => {
        setOpenItems((prev) => prev.includes(index) ? prev.filter(item => item !== index) : [...prev, index]);
    };

    return (

        <section className="mb-3" id="education">

            <h2 className="section-title">
                <i className="fas fa-graduation-cap"></i><span style={{ marginLeft: "10px" }}>Education</span>
            </h2>

            {
                education.map((edu, index) => {

                    const hasDetails = Boolean(edu.details?.length);
                    const isOpen = openItems.includes(index);

                    return (

                        <div key={index} className={`work-experience-item education-item ${isOpen ? "open" : ""}`}>

                            <div
                                className={`experience-header ${hasDetails ? "" : "not-expandable"}`}
                                onClick={() => hasDetails && toggleDetails(index)}
                            >

                                <img src={getLogo(getOrganization(edu.institution))} alt="institution-logo" className="organization-logo" />

                                <div className="experience-heading">
                                    <h5 className="experience-title">{edu.degree}</h5>
                                    <div className="experience-meta">
                                        <span>{edu.institution}</span>
                                        <span className="experience-meta-separator">•</span>
                                        <span>{edu.duration}</span>
                                    </div>
                                </div>

                                <span className="education-grade">{edu.grade}</span>

                                {
                                    hasDetails
                                        ? (
                                            <button
                                                className="toggle-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleDetails(index);
                                                }}
                                                aria-label="Toggle Education Details"
                                            >
                                                {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                                            </button>
                                        )
                                        : <span className="toggle-btn-placeholder" />
                                }

                            </div>

                            {
                                isOpen && (
                                    <div className="experience-details">
                                        {edu.details.map((detail, idx) => (
                                            <div key={idx} className="education-detail">{detail}</div>
                                        ))}
                                    </div>
                                )
                            }

                        </div>

                    );

                })
            }

        </section>

    );

};

export default Education;
